$(document).ready(function() {
    /* Select active menu */
    var adress = window.location.pathname;
    first =adress.split('/');
    first = first[1];
    if (adress=='/kontakt'){
        $('.contact-us').css('display','none');
    }
    if(adress == '/') {
        $( ".navbar-nav > li" ).eq(0).addClass('active');
    } else {
        $( ".navbar-nav > li" ).each(function( index ) {
            if($(this).html().indexOf(adress)>0) {
                $( ".navbar-nav > li .active" ).removeClass('active');
                $(this).addClass('active');
                      if ($(this).hasClass('dropdown')) {
                    console.log(this);
                    $(this).find('ul li').each(function( index ) {
                        if($(this).html().indexOf(adress) > 0) {
                            $(this).addClass('active');
                        }
                    });
                }
                first = null;
                return;
            } 
        });
    } 
    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
  });
});
$('document').ready(function(){

    $('#expand1').click(function(){
        $('#expand-content1').toggleClass('contact-widgate__form--label-visible');
        $(this).toggle();
    });

    $('#expand2').click(function(){
        $('#expand-content2').toggleClass('contact-widgate__form--label-visible');
        $(this).toggle();
    });

});


$(document).ready(function(){

    $('button.navbar-toggle').click(function(){

        $('html').toggleClass('overflow');
    });

});

  $(document).ready(function() {
        $("img").unveil();
    });
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (screen.width > 992){

        //>=, not <=
        if (scroll >= 50) {
            //clearHeader, not clearheader - caps H
            $(".logo").addClass("shrink");
            $(".menu").addClass("shrink");
        }
        else
        {
            $(".logo").removeClass("shrink");
            $(".menu").removeClass("shrink");
        }
    }
    }); //missing );


$(document).ready(function(){
                $('#menu > nav > div > div.navbar-header > button').click(function(){
                    $(this).toggleClass('open');
                });
            });

    $( document ).ready(function() {
        function setParallax()
        {
            $('.contact-us').parallax({imageSrc: '/media/default/contact.jpg'});
            $('.our-realizations-container-wrapper').parallax({imageSrc: '/media/default/nasze-realizacje.jpg'});
        }
        setTimeout(setParallax, 0)
    });


//# sourceMappingURL=default.js.map
